// 토글 스위치 행 — 라벨 + role=switch (정책 관리 / 시스템 설정 공용)
export function ToggleRow({ label, on, onClick }: { label: string; on: boolean; onClick: () => void }) {
  return (
    <div className="toggle-row">
      <span className="toggle-label">{label}</span>
      <div
        role="switch"
        aria-checked={on}
        aria-label={label}
        tabIndex={0}
        className={`toggle ${on ? 'on' : ''}`}
        onClick={onClick}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
      />
    </div>
  );
}
